import { apiFetch } from './api'
import { getOrCreateVisitorId } from './visitor'

type VisitEventInput = {
  path: string
  source?: string
  method?: string
  signal?: AbortSignal
}

export const sendVisitTelemetry = async ({ path, source = 'app', method = 'view', signal }: VisitEventInput) => {
  const visitorId = getOrCreateVisitorId()
  try {
    await apiFetch('/api/telemetry/visit', {
      method: 'POST',
      auth: false,
      body: JSON.stringify({ path, source, method, visitorId }),
      signal,
    })
  } catch {
    // Telemetry is best-effort; swallow failures to avoid user-facing noise.
  }
}
